import React from "react";

import * as Styles from "./styles";

const instructionsHowToUsePix = [
  "Acesse o Internet Baking ou aplicativo do seu banco",
  "Acesse a opção Pix",
  "Selecione a opção Pix Copia e Cola",
  "Cole o código no campo indicado e confirme o pagamento",
  "Pronto! Sua recarga será feita em até 5 minutos. Aproveite seus benefícios",
];

export function PixPaymentInstructionsDrawer({ children }) {
  return (
    <Styles.Root>
      <Styles.Trigger asChild>{children}</Styles.Trigger>
      <Styles.Portal>
        <Styles.Overlay />
        <Styles.Content>
          <Styles.Title>Como fazer sua recarga com o PIX:</Styles.Title>
          <Styles.InstructionsList>
            {instructionsHowToUsePix.map((instruction, index) => (
              <li key={index}>{instruction}</li>
            ))}
          </Styles.InstructionsList>
        </Styles.Content>
      </Styles.Portal>
    </Styles.Root>
  );
}
